import React from 'react';
import { Link } from 'react-router-dom';
import LogoButton from './logoButoen';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error("Error atrapado por ErrorBoundary:", error, errorInfo);
  }
render() {
  if (this.state.hasError) {
    return (
      <div className='padron'>
        <div className='top-bar2'>
          <div className="top-bar">
            <div className="logo">
             <LogoButton />
            </div>
          </div>
        </div>

        <div style={{
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 0 10px rgba(0,0,0,0.1)',
          padding: '30px',
          maxWidth: '800px',
          margin: '40px auto',
          fontFamily: 'Arial, sans-serif'
        }}>
          <h2 style={{ color: '#cc0000', marginBottom: '1rem' }}>❌ Módulo no disponible</h2>

          <h2 style={{ color: '#cc0000', marginBottom: '1rem' }}>❌ Error en el servidor, Favor de consultar al administrador del sistema</h2>


          {process.env.REACT_APP_NODE_ENVE === 'development' && (
            <>

          <p style={{ fontWeight: 'bold', color: '#cc0000' }}>
            {this.state.error?.message}
          </p>
              {this.state.error?.backendMessage && (
                <p>
                  <strong>Mensaje backend:</strong>
                  <pre style={{ whiteSpace: 'pre-wrap', background: '#eee', padding: '10px', borderRadius: '4px' }}>
                    {this.state.error.backendMessage}
                  </pre>
                </p>
              )}

              {this.state.error?.stack && (
                <details style={{ whiteSpace: 'pre-wrap', color: '#333', marginTop: '20px' }}>
                  <summary style={{ cursor: 'pointer', marginBottom: '10px', fontWeight: 'bold' }}>
                    Ver stack del error
                  </summary>
                  {this.state.error.stack}
                </details>
              )}
            </>
          )}
        </div>
      </div>
    );
  }

  return this.props.children;
}

}

export default ErrorBoundary;
